import $ from 'jquery';

const isPhone = $('body').hasClass('phone');

export function isIOS() {
    return /ipad|iphone|ipod/i.test(navigator.userAgent);
}

export function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

if(isIOS() && isSafari()) {
    // Der Safari auf iOS zoomt auf Eingabefelder, wenn man reintippt:
    // https://stackoverflow.com/questions/2989263/disable-auto-zoom-in-input-text-tag-safari-on-iphone
    const $viewport = $('meta[name="viewport"]');
    $viewport.attr('content', $viewport.attr('content') + ', maximum-scale=1');
}

export {isPhone};
